"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/web.dom.iterable");

var _big_cat_for_sale_list = require("@/api/big_cat_for_sale_list");

var _big_cat_sort = require("@/api/big_cat_sort");

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      catList: null,
      listLoading: true,
      activeName: 'first',
      catIdList: []
    };
  },
  components: {
    vuedraggable: _vuedraggable.default
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      (0, _big_cat_for_sale_list.getBigCatList)().then(function (response) {
        var catList = response.data;
        var _catList = [];
        (0, _big_cat_sort.getBigCatSortList)().then(function (bigCatSortList) {
          // 第一次排序，数据库中排序记录为空，所以直接按照默认排序展示
          if (!bigCatSortList.data) {
            _this.catList = catList;
            return;
          } else {
            var sortList = bigCatSortList.data.list;
            sortList.split(',').forEach(function (id) {
              catList.forEach(function (cat, catI) {
                if (cat.id == id) {
                  _catList.push(cat);

                  catList.splice(catI, 1);
                }
              });
            });

            if (catList.length > 0) {
              _this.catList = _catList.concat(catList);
            } else {
              _this.catList = _catList;
            }
          }
        });
      });
    },
    // 拖拽动作完成后，获取最新列表并保存
    end: function end() {
      var _this2 = this;

      var $ = this;
      $.catIdList = [];
      $.catList.forEach(function (cat, catI) {
        $.catIdList.push(cat.id);
      });
      $.$store.dispatch('big_cat_sort/edit', {
        big_cat_sort_list: $.catIdList
      }).then(function (data) {
        console.log(data);

        _this2.$message({
          message: data.msg,
          type: 'success'
        });
      }).catch(function () {
        _this2.loading = false;
      });
    }
  }
};
exports.default = _default;